import { render } from "./Applicants.vue?vue&type=template&id=26dd1b04"
import script from "./Applicants.vue?vue&type=script&lang=js"
export * from "./Applicants.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__